
export enum CapitalizationType {
	DEFAULT = 'default',
	LOWERCASE = 'lowercase',
	UPPERCASE = 'uppercase',
	SENTENCE_CASE = 'sentenceCase',
	FIRST_LETTER = 'firstLetter'
}
